import { AppBar, ListItemIcon, Menu, MenuItem, Toolbar } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import useAuthUser from 'react-auth-kit/hooks/useAuthUser'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import LogoutIcon from '@mui/icons-material/Logout'
import CustomIconButton from './IconButton'
import { MouseEvent, useContext, useState } from 'react'
import { AuthenticatedUserData } from '../models/auth'
import useLogout from '../hooks/useLogout'
import { AppRoutes } from '../helpers/routes'
import UserService from '../services/UserService'
import { UserDTO } from '../models/users'
import { isAdmin } from '../helpers/utils'
import SearchIcon from '@mui/icons-material/Search'
import CustomModal from '../containers/Modal'
import SearchGraduatesModal from './Modal/SearchGraduatesModal'
import MenuIcon from '@mui/icons-material/Menu'
import { PageContext } from '../context/PageContext'

const Navbar = () => {
    const { pathname } = useLocation()
    const hiddenAt = [
        'login',
        'register',
        'recover-password',
        'recovery-code',
        'new-password',
        'activateUser',
        'activateLinkedinUser',
        'pending-user',
        'validate',
    ]
    const userData: AuthenticatedUserData | null = useAuthUser()
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
    const navigate = useNavigate()
    const { setShowSidebar } = useContext(PageContext)

    const showNavbar = () => {
        return hiddenAt.every((path) => !pathname.includes(path))
    }

    return (
        <div>
            {showNavbar() && (
                <AppBar
                    position="static"
                    className="bg-secondary shadow-none h-[64px]"
                >
                    <Toolbar className="flex justify-between">
                        <div className="flex gap-4 items-center">
                            <CustomIconButton
                                icon={<MenuIcon />}
                                className="text-white block md:hidden"
                                title="Buscar graduados"
                                onClick={() => setShowSidebar((prev) => !prev)}
                            />
                            <img
                                src="/logo.png"
                                alt="logo"
                                className="h-10 py-3"
                                style={{ filter: 'brightness(0) invert(1)' }}
                            />
                            <span className="text-xl hidden md:block">
                                Sistema de Seguimiento de Graduados
                            </span>
                        </div>
                        <div className="flex gap-6 items-center">
                            <CustomIconButton
                                icon={<SearchIcon />}
                                className="text-white"
                                title="Buscar graduados"
                                onClick={() => setIsModalOpen(true)}
                            />
                            <div className="flex gap-1 items-center">
                                <img
                                    src={
                                        userData?.picture !== ''
                                            ? userData?.picture
                                            : '/adminPhoto.png'
                                    }
                                    alt="user"
                                    className="h-10 w-10 py-3 rounded-[100%] mr-2"
                                />
                                <span className="text-lg hidden md:block">
                                    {userData?.fullName ?? 'Usuario'}
                                </span>
                                <AccountMenu />
                            </div>
                        </div>
                    </Toolbar>
                    <CustomModal
                        isOpen={isModalOpen}
                        handleClose={() => setIsModalOpen(false)}
                    >
                        <SearchGraduatesModal
                            text="Buscar graduados"
                            handleClose={() => setIsModalOpen(false)}
                            handleSelectGraduate={(user) =>
                                navigate(AppRoutes.user.replace(':userId', user.id))
                            }
                        />
                    </CustomModal>
                </AppBar>
            )}
        </div>
    )
}

const AccountMenu = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const openMenu = Boolean(anchorEl)
    const navigate = useNavigate()
    const logout = useLogout()
    const { setShowSidebar } = useContext(PageContext)

    const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleLogOut = async () => {
        logout(AppRoutes.login)
    }

    const handleProfile = async () => {
        setAnchorEl(null)
        const userInfo = await new UserService().getCurrentUser()
        if (userInfo.status === 200) {
            const userId = (userInfo.data as UserDTO).id
            navigate(AppRoutes.user.replace(':userId', userId))
            setShowSidebar(false)
        }
    }

    return (
        <div>
            <CustomIconButton
                icon={<ExpandMoreIcon className="text-white" />}
                onClick={handleOpen}
            />
            <Menu
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                    className: 'bg-secondary text-white',
                    sx: {
                        width: anchorEl?.offsetWidth ?? 'auto',
                        minWidth: '180px',
                    },
                }}
                anchorEl={anchorEl}
                id="basic-menu"
                open={openMenu}
                onClose={() => setAnchorEl(null)}
                slotProps={{ paper: { sx: { backgroundColor: '#333752' } } }}
                sx={{ marginTop: '5px' }}
            >
                {!isAdmin() && (
                    <MenuItem
                        onClick={handleProfile}
                        className="bg-secondary"
                    >
                        <ListItemIcon>
                            <AccountCircleIcon
                                className="text-white"
                                fontSize="small"
                            />
                        </ListItemIcon>
                        <span>Ver Perfil</span>
                    </MenuItem>
                )}
                <MenuItem
                    onClick={handleLogOut}
                    className="bg-secondary"
                >
                    <ListItemIcon>
                        <LogoutIcon
                            className="text-white"
                            fontSize="small"
                        />
                    </ListItemIcon>
                    <span>Cerrar Sesión</span>
                </MenuItem>
            </Menu>
        </div>
    )
}

export default Navbar
